import Svg from '../generated/Error';
import { Icon, type IconProps } from './Icon';

export const ErrorIcon = (props: IconProps) => <Icon component={Svg} name="error" {...props} />;
